export default "__VITE_ASSET__CJCWd2SX__"